import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import DrawerFilter from '../../components/Leads/DrawerFilter';
import LeadForm from '../../components/Leads/Form';
import Table from '../../components/Leads/Table';
import {Context} from '../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
// import {getLeadStatus, getLeads} from '../api';

import {getCategoriasArtigos, getMarcas, getModelos, getNacionaisInternacionais, getPaises, getRepresentantes, getTipos} from '../../pages/requests';
import {getLeadStatus} from '../../components/Leads/api';

export default function Leads() {
    const {t} = useTranslation();
    const {path, setPath} = useContext(Context);
    const [loading, setLoading] = useState(false);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    // Apresenta form de leads ou não
    const [showForm, setShowForm] = useState(false);

    // Separador do form que está visivel
    const [openTab, setOpenTab] = useState(1);

    // Lead que está selecionado
    const [leadSelecionado, setLeadSelecionado] = useState('');

    // flag para guardar Lead
    const [guardarLead, setGuardarLead] = useState(false);

    // Indica se o form está em modo de edição ou não
    const [editarLead, setEditarLead] = useState(false);

    const [download, setDownload] = useState(false);

    //FILTROS
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroRazaoSocial, setFiltroRazaoSocial] = useState('');
    const [filtroNIF, setFiltroNIF] = useState('');
    const [filtroStatus, setFiltroStatus] = useState(null);
    const [filtroMarca, setFiltroMarca] = useState(null);
    const [filtroCategoria, setFiltroCategoria] = useState(null);
    const [filtroNacionalInternacional, setFiltroNacionalInternacional] = useState(null);
    const [filtroTipo, setFiltroTipo] = useState(null);
    const [filtroModelo, setFiltroModelo] = useState(null);
    const [filtroCidade, setFiltroCidade] = useState('');
    const [filtroPais, setFiltroPais] = useState(null);
    const [filtroRepresentante, setFiltroRepresentante] = useState(null);

    //OPTIONS
    const [optionsPais, setOptionsPais] = useState([]);
    const [optionsStatus, setOptionsStatus] = useState([]);
    const [optionsMarca, setOptionsMarca] = useState([]);
    const [optionsNacionaisInternacionais, setOptionsNacionaisInternacionais] = useState([]);
    const [optionsTipo, setOptionsTipo] = useState([]);
    const [optionsModelo, setOptionsModelo] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [optionsRepresentante, setOptionsRepresentante] = useState([]);

    const handleRowClick = dados => {
        setLeadSelecionado(dados);
        setShowForm(true);
        setEditarLead(false);
        setOnChangeForm(false);
    };

    useEffect(() => {
        if (showForm && !leadSelecionado) {
            setPath(t('criarLeads'));
        } else if (showForm && leadSelecionado) {
            setPath(t('Editar Lead') + ' ' + leadSelecionado.codigo + ' - ' + leadSelecionado.cortesia.descricao + ' ' + leadSelecionado.apelido);
        } else {
            setPath('');
        }
    }, [path, showForm]);

    const [novaConta, setNovaConta] = useState(false);

    const [novaReuniaoVisita, setNovaReuniaoVisita] = useState(false);

    // flag com indicação de se foram efetuados alterações no prospect
    const [onChangeForm, setOnChangeForm] = useState(false);

    useEffect(() => {
        setLoading(true);
        var promises = [];

        // promises.push(
        //     getCategoriasArtigos(lang).then(res => {
        //         if (res.data.success) {
        //             setCategorias(res.data.categorias);
        //         }
        //     }),
        // );
        // promises.push(
        //     getMarcas(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsMarca(res.data.marcas);
        //         }
        //     }),
        // );

        // promises.push(
        //     getNacionaisInternacionais(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsNacionaisInternacionais(res.data.nacionaisInternacionais);
        //         }
        //     }),
        // );

        // promises.push(
        //     getTipos(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsTipo(res.data.tipos);
        //         }
        //     }),
        // );

        // promises.push(
        //     getModelos(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsModelo(res.data.modelos);
        //         }
        //     }),
        // );

        // promises.push(
        //     getLeadStatus(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsStatus(res.data.status);
        //         }
        //     }),
        // );
        // promises.push(
        //     getRepresentantes(lang).then(res => {
        //         setOptionsRepresentante(res.data?.representantes);
        //     }),
        // );

        // promises.push(
        //     getPaises(lang).then(res => {
        //         if (res.data.success) {
        //             setOptionsPais(res.data.paises);
        //         }
        //     }),
        // );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);
    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div className="flex flex-row justify-end dark:text-gray-400 text-gray-500">
                    <DrawerFilter
                        download={download}
                        setDownload={setDownload}
                        onChangeForm={onChangeForm}
                        showForm={showForm}
                        setShowForm={setShowForm}
                        editarLead={editarLead}
                        setEditarLead={setEditarLead}
                        setGuardarLead={setGuardarLead}
                        leadSelecionado={leadSelecionado}
                        setLeadSelecionado={setLeadSelecionado}
                        setNovaConta={setNovaConta}
                        setNovaReuniaoVisita={setNovaReuniaoVisita}
                        setFiltroNome={setFiltroNome}
                        filtroNome={filtroNome}
                        setFiltroRazaoSocial={setFiltroRazaoSocial}
                        filtroRazaoSocial={filtroRazaoSocial}
                        setFiltroNIF={setFiltroNIF}
                        filtroNIF={filtroNIF}
                        setFiltroStatus={setFiltroStatus}
                        filtroStatus={filtroStatus}
                        setFiltroCategoria={setFiltroCategoria}
                        filtroCategoria={filtroCategoria}
                        filtroMarca={filtroMarca}
                        setFiltroMarca={setFiltroMarca}
                        setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                        filtroNacionalInternacional={filtroNacionalInternacional}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        setFiltroModelo={setFiltroModelo}
                        filtroModelo={filtroModelo}
                        setFiltroCidade={setFiltroCidade}
                        filtroCidade={filtroCidade}
                        setFiltroPais={setFiltroPais}
                        filtroPais={filtroPais}
                        optionsPais={optionsPais}
                        optionsMarca={optionsMarca}
                        optionsModelo={optionsModelo}
                        optionsNacionaisInternacionais={optionsNacionaisInternacionais}
                        optionsStatus={optionsStatus}
                        optionsRepresentante={optionsRepresentante}
                        filtroRepresentante={filtroRepresentante}
                        setFiltroRepresentante={setFiltroRepresentante}
                        optionsTipo={optionsTipo}
                        categorias={categorias}
                    />
                </div>
                <div
                    className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <div className="flex space-x-2">
                        <div className={showForm ? 'block' : 'hidden'}>
                            <button
                                aria-controls="agenda"
                                id="agenda-tab"
                                type="button"
                                data-toggle="tab"
                                href="#link1"
                                role="tablist"
                                aria-current="page"
                                className={
                                    'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                    (openTab === 1
                                        ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                        : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                }
                                onClick={e => {
                                    e.preventDefault();
                                    setOpenTab(1);
                                }}>
                                <PublicOutlinedIcon className="mr-2" />
                                {t('detalhes')}
                            </button>
                            <button
                                aria-controls="calendario"
                                id="calendario-tab"
                                data-toggle="tab"
                                href="#link2"
                                role="tablist"
                                type="button"
                                className={
                                    'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                    (openTab === 2
                                        ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                        : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                }
                                onClick={e => {
                                    e.preventDefault();
                                    setOpenTab(2);
                                }}>
                                <FmdGoodOutlinedIcon className="mr-2" />
                                {t('endereco')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {!showForm && (
                <Table
                setOptionsModelo={setOptionsModelo}
                setOptionsPais={setOptionsPais}
                setOptionsTipo={setOptionsTipo}
                setOptionsNacionaisInternacionais={setOptionsNacionaisInternacionais}
                setOptionsMarca={setOptionsMarca}
                setCategorias={setCategorias}
                setOptionsStatus={setOptionsStatus}
                setOptionsRepresentante={setOptionsRepresentante}
                    download={download}
                    setDownload={setDownload}
                    loading={loading}
                    setLoading={setLoading}
                    setFiltroNome={setFiltroNome}
                    filtroNome={filtroNome}
                    setFiltroRazaoSocial={setFiltroRazaoSocial}
                    filtroRazaoSocial={filtroRazaoSocial}
                    setFiltroNIF={setFiltroNIF}
                    filtroNIF={filtroNIF}
                    setFiltroStatus={setFiltroStatus}
                    filtroStatus={filtroStatus}
                    setFiltroCategoria={setFiltroCategoria}
                    filtroCategoria={filtroCategoria}
                    filtroMarca={filtroMarca}
                    setFiltroMarca={setFiltroMarca}
                    setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                    filtroNacionalInternacional={filtroNacionalInternacional}
                    filtroTipo={filtroTipo}
                    setFiltroTipo={setFiltroTipo}
                    setFiltroModelo={setFiltroModelo}
                    filtroModelo={filtroModelo}
                    setFiltroCidade={setFiltroCidade}
                    filtroCidade={filtroCidade}
                    setFiltroPais={setFiltroPais}
                    filtroPais={filtroPais}
                    onRowClick={handleRowClick}
                    optionsPais={optionsPais}
                    optionsMarca={optionsMarca}
                    optionsModelo={optionsModelo}
                    optionsNacionaisInternacionais={optionsNacionaisInternacionais}
                    optionsStatus={optionsStatus}
                    optionsRepresentante={optionsRepresentante}
                    filtroRepresentante={filtroRepresentante}
                    setFiltroRepresentante={setFiltroRepresentante}
                    optionsTipo={optionsTipo}
                    categorias={categorias}
                />
            )}

            {showForm && (
                <LeadForm
                    onChangeForm={onChangeForm}
                    setOnChangeForm={setOnChangeForm}
                    leadSelecionado={leadSelecionado}
                    setShowForm={setShowForm}
                    setOpenTab={setOpenTab}
                    openTab={openTab}
                    setGuardarLead={setGuardarLead}
                    guardarLead={guardarLead}
                    editarLead={editarLead}
                    setEditarLead={setEditarLead}
                    setNovaConta={setNovaConta}
                    novaConta={novaConta}
                    setNovaReuniaoVisita={setNovaReuniaoVisita}
                    novaReuniaoVisita={novaReuniaoVisita}
                />
            )}
        </>
    );
}
